import * as React from 'react'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Stack from '@mui/material/Stack'
import { SxProps, Theme } from '@mui/material/styles'
import { ICompanyHeaderDisplaySettingsDTO } from '@user/store/companyHeaderDisplaySettings'

interface HeaderDisplay {
  name: keyof ICompanyHeaderDisplaySettingsDTO
  checked: boolean
  disabled: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  testId: string
}

export const COMPANY_INFO_LABEL_WIDTH = 160
export const COMPANY_INFO_VALUE_WIDTH = 380
export const COMPANY_INFO_VALUE_SM_WIDTH = 300

interface Props {
  label: React.ReactNode
  value: React.ReactNode
  labelSx?: SxProps<Theme>
  headerDisplay?: HeaderDisplay
}

export function CompanyInfoRow(props: Props) {
  const { label, value, labelSx, headerDisplay } = props
  return (
    <Stack direction="row" alignItems="center" pb="10px">
      <Box
        sx={[
          { width: COMPANY_INFO_LABEL_WIDTH },
          ...(Array.isArray(labelSx) ? labelSx : [labelSx]),
        ]}
      >
        {label}
      </Box>
      <Box
        sx={{
          width: {
            sm: COMPANY_INFO_VALUE_SM_WIDTH,
            md: COMPANY_INFO_VALUE_WIDTH,
          },
        }}
      >
        {value}
      </Box>
      {headerDisplay && (
        <Checkbox
          color="primary"
          size="small"
          sx={{ p: 0 }}
          name={headerDisplay.name}
          checked={headerDisplay.checked}
          disabled={headerDisplay.disabled}
          onChange={headerDisplay.onChange}
          data-test-id={headerDisplay.testId}
        />
      )}
    </Stack>
  )
}

CompanyInfoRow.displayName = 'CompanyInfoRow'
